// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#scrollspy-example[data-v-b51da3d4]{position:relative;height:200px;overflow-y:scroll;border:1px solid #00f}", ""]);
// Exports
module.exports = exports;
